import { useMapTokenPropsToCSS } from 'foundations-components/hooks/useMapTokenPropsToCSS';
import { CardGrid } from 'foundations-components/transitional/components/CardGrid';
import { View } from 'foundations-components/transitional/components/View';
import { useSearchParams } from 'marketplace-ui-common/hooks/useSearchParams';
import { useEffect, useRef, useState } from 'react';
import { StorefrontListingCard } from '../../components/cards/StorefrontListingCard';
import { useSearchResultsQuery } from '../hooks/useSearchResultsQuery';
import { AiSummaryCard } from './AiSummaryCard';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const COLUMN_WIDTH = 300;
export const GAP_TOKEN = '600';
export function ResultsGridWithSummary() {
  var _params$get, _data$result$cards, _data$result$aiAnswer, _data$result$aiReques;
  const {
    data,
    queryType
  } = useSearchResultsQuery();
  const mainGridRef = useRef(null);
  const subGridRef = useRef(null);
  const mainGridResizeObserverRef = useRef(null);
  const [columnCount, setColumnCount] = useState(0);
  const [subGridHeight, setSubGridHeight] = useState(0);
  const params = useSearchParams();
  const pageNumber = parseInt((_params$get = params.get('page')) !== null && _params$get !== void 0 ? _params$get : '1', 10);
  const searchTerm = params.get('search');

  // get the pixel int from the Trellis token
  const columnGap = parseInt(useMapTokenPropsToCSS({
    gap: GAP_TOKEN
  }).gap, 10);
  useEffect(() => {
    if (!(data !== null && data !== void 0 && data.result.total)) return;
    const handleResize = () => {
      var _mainGridRef$current, _subGridRef$current$c, _subGridRef$current;
      if (!((_mainGridRef$current = mainGridRef.current) !== null && _mainGridRef$current !== void 0 && _mainGridRef$current.firstElementChild)) return;
      const newColumnCount = Math.floor((mainGridRef.current.clientWidth + columnGap) / (COLUMN_WIDTH + columnGap));
      setSubGridHeight((_subGridRef$current$c = (_subGridRef$current = subGridRef.current) === null || _subGridRef$current === void 0 ? void 0 : _subGridRef$current.clientHeight) !== null && _subGridRef$current$c !== void 0 ? _subGridRef$current$c : 0);
      if (newColumnCount === columnCount) return;
      setColumnCount(newColumnCount);
    };
    if (mainGridRef.current) {
      mainGridResizeObserverRef.current = new ResizeObserver(handleResize);
      mainGridResizeObserverRef.current.observe(mainGridRef.current);
    }
    handleResize();
    return () => {
      if (mainGridResizeObserverRef.current) {
        mainGridResizeObserverRef.current.disconnect();
        mainGridResizeObserverRef.current = null;
      }
    };
  }, [data === null || data === void 0 ? void 0 : data.result.total, columnCount, columnGap]);
  const cards = (_data$result$cards = data === null || data === void 0 ? void 0 : data.result.cards) !== null && _data$result$cards !== void 0 ? _data$result$cards : [];
  const firstRowSlots = Math.max(0, columnCount - 2);
  return /*#__PURE__*/_jsx("div", {
    ref: mainGridRef,
    children: /*#__PURE__*/_jsxs(CardGrid, {
      columnSize: COLUMN_WIDTH,
      gap: GAP_TOKEN,
      children: [/*#__PURE__*/_jsx(AiSummaryCard, {
        aiAnswer: (_data$result$aiAnswer = data === null || data === void 0 ? void 0 : data.result.aiAnswer) !== null && _data$result$aiAnswer !== void 0 ? _data$result$aiAnswer : '',
        aiRequestId: (_data$result$aiReques = data === null || data === void 0 ? void 0 : data.result.aiRequestId) !== null && _data$result$aiReques !== void 0 ? _data$result$aiReques : '',
        gridIsSingleColumn: columnCount === 1,
        maxHeight: subGridHeight || 300
      }), firstRowSlots > 0 && /*#__PURE__*/_jsx(View
      // @ts-expect-error gridColumn is valid
      , {
        gridColumn: `span ${firstRowSlots}`,
        children: /*#__PURE__*/_jsx("div", {
          ref: subGridRef,
          children: /*#__PURE__*/_jsx(CardGrid, {
            columnSize: COLUMN_WIDTH,
            gap: GAP_TOKEN,
            children: cards.slice(0, firstRowSlots).map((card, index) => /*#__PURE__*/_jsx(StorefrontListingCard, {
              card: card,
              pageNumber: pageNumber,
              queryType: queryType,
              resultCount: cards.length,
              resultIndex: index + 1,
              searchTerm: searchTerm
            }, card.listingId))
          })
        })
      }), cards.slice(firstRowSlots).map((card, index) => /*#__PURE__*/_jsx(StorefrontListingCard, {
        card: card,
        pageNumber: pageNumber,
        queryType: queryType,
        resultCount: cards.length,
        resultIndex: index + 1,
        searchTerm: searchTerm
      }, card.listingId))]
    })
  });
}